<template>
    <wsm :class="[$root.isadmin && translationMode ? 'wsmContainer' : '', active || openTranslator ? 'activeElHoverWsm' : '']">
        <VHTML :html="newText" />
        <transition name="bounce">
            <span class="langBtn" v-if="!loading && $root.isadmin && translationMode" :style="{ 'left': howFarLeft }" @mouseover="active = true;" ref="transIcon" @click="openTranslator = !openTranslator;disableLink()" @mouseleave="active = false" :class="[openTranslator ? 'activeIcon' : '']">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 512"><!-- Font Awesome Free 5.15.4 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free (Icons: CC BY 4.0, Fonts: SIL OFL 1.1, Code: MIT License) --><path d="M152.1 236.2c-3.5-12.1-7.8-33.2-7.8-33.2h-.5s-4.3 21.1-7.8 33.2l-11.1 37.5H163zM616 96H336v320h280c13.3 0 24-10.7 24-24V120c0-13.3-10.7-24-24-24zm-24 120c0 6.6-5.4 12-12 12h-11.4c-6.9 23.6-21.7 47.4-42.7 69.9 8.4 6.4 17.1 12.5 26.1 18 5.5 3.4 7.3 10.5 4.1 16.2l-7.9 13.9c-3.4 5.9-10.9 7.8-16.7 4.3-12.6-7.8-24.5-16.1-35.4-24.9-10.9 8.7-22.7 17.1-35.4 24.9-5.8 3.5-13.3 1.6-16.7-4.3l-7.9-13.9c-3.2-5.6-1.4-12.8 4.2-16.2 9.3-5.7 18-11.7 26.1-18-7.9-8.4-14.9-17-21-25.7-4-5.7-2.2-13.6 3.7-17.1l6.5-3.9 7.3-4.3c5.4-3.2 12.4-1.7 16 3.4 5 7 10.8 14 17.4 20.9 13.5-14.2 23.8-28.9 30-43.2H412c-6.6 0-12-5.4-12-12v-16c0-6.6 5.4-12 12-12h64v-16c0-6.6 5.4-12 12-12h16c6.6 0 12 5.4 12 12v16h64c6.6 0 12 5.4 12 12zM0 120v272c0 13.3 10.7 24 24 24h280V96H24c-13.3 0-24 10.7-24 24zm58.9 216.1L116.4 167c1.7-4.9 6.2-8.1 11.4-8.1h32.5c5.1 0 9.7 3.3 11.4 8.1l57.5 169.1c2.6 7.8-3.1 15.9-11.4 15.9h-22.9a12 12 0 0 1-11.5-8.6l-9.4-31.9h-60.2l-9.1 31.8c-1.5 5.1-6.2 8.7-11.5 8.7H70.3c-8.2 0-14-8.1-11.4-15.9z"/></svg>
            </span>
        </transition>
        <transition name="bounce">
            <div v-if="openTranslator && $root.isadmin && translationMode" :class="['translateWindow']">
                <span @click="openTranslator = !openTranslator" class="close">
                    
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512"><!--! Font Awesome Pro 6.1.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2022 Fonticons, Inc. -->
                        <path d="M310.6 361.4c12.5 12.5 12.5 32.75 0 45.25C304.4 412.9 296.2 416 288 416s-16.38-3.125-22.62-9.375L160 301.3L54.63 406.6C48.38 412.9 40.19 416 32 416S15.63 412.9 9.375 406.6c-12.5-12.5-12.5-32.75 0-45.25l105.4-105.4L9.375 150.6c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0L160 210.8l105.4-105.4c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25l-105.4 105.4L310.6 361.4z"/>
                    </svg>
                </span>
                <transition name="fading" mode="out-in">
                 <div v-if="loadingData" class="loadingWrapper" key="loadingWrapper">
                       
                        <div class="loadingIconWrapper">
                            <div class="loadingIconBackground">
                                <div class="loadingCircle"></div>
                                <svg class="loadingIcon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 512">
                                <!--! Font Awesome Pro 6.1.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2022 Fonticons, Inc. -->
                                <path d="M448 164C459 164 468 172.1 468 184V188H528C539 188 548 196.1 548 208C548 219 539 228 528 228H526L524.4 232.5C515.5 256.1 501.9 279.1 484.7 297.9C485.6 298.4 486.5 298.1 487.4 299.5L506.3 310.8C515.8 316.5 518.8 328.8 513.1 338.3C507.5 347.8 495.2 350.8 485.7 345.1L466.8 333.8C462.4 331.1 457.1 328.3 453.7 325.3C443.2 332.8 431.8 339.3 419.8 344.7L416.1 346.3C406 350.8 394.2 346.2 389.7 336.1C385.2 326 389.8 314.2 399.9 309.7L403.5 308.1C409.9 305.2 416.1 301.1 422 298.3L409.9 286.1C402 278.3 402 265.7 409.9 257.9C417.7 250 430.3 250 438.1 257.9L452.7 272.4L453.3 272.1C465.7 259.9 475.8 244.7 483.1 227.1H376C364.1 227.1 356 219 356 207.1C356 196.1 364.1 187.1 376 187.1H428V183.1C428 172.1 436.1 163.1 448 163.1L448 164zM160 233.2L179 276H140.1L160 233.2zM0 128C0 92.65 28.65 64 64 64H576C611.3 64 640 92.65 640 128V384C640 419.3 611.3 448 576 448H64C28.65 448 0 419.3 0 384V128zM320 384H576V128H320V384zM178.3 175.9C175.1 168.7 167.9 164 160 164C152.1 164 144.9 168.7 141.7 175.9L77.72 319.9C73.24 329.1 77.78 341.8 87.88 346.3C97.97 350.8 109.8 346.2 114.3 336.1L123.2 315.1H196.8L205.7 336.1C210.2 346.2 222 350.8 232.1 346.3C242.2 341.8 246.8 329.1 242.3 319.9L178.3 175.9z"/>
                                </svg>
                            </div>
                        </div>
                </div>
                </transition>

                <div class="translateWindowInnerWrapper" key="translateWindowInnerWrapper">
                    <div class="infoContainer">
                        <p class="infoTitle">Cluster: <span v-html="selectedCluster.clusterName"></span></p>
                        <p class="infoTitle">Webmessage key: <span v-html="searchKey"></span></p>
                        <p class="infoTitle">Language: <span v-html="language"></span></p></div>
                    <div v-if="!isAllowedToEdit" class="notAllowedContainer">
                        <div class="notAllowedInnerWrapper">
                        <div class="notAllowedIconWrapper">
                        <svg class="notAllowedIcon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><!--! Font Awesome Pro 6.1.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2022 Fonticons, Inc. --><path d="M224 337.1c-17.36 0-31.44 14.08-31.44 31.44C192.6 385.9 206.6 400 224 400s31.44-14.08 31.44-31.44C255.4 351.2 241.4 337.1 224 337.1zM224 304c13.25 0 24-10.75 24-24v-128C248 138.8 237.3 128 224 128S200 138.8 200 152v128C200 293.3 210.8 304 224 304zM384 32H64C28.65 32 0 60.65 0 96v320c0 35.35 28.65 64 64 64h320c35.35 0 64-28.65 64-64V96C448 60.65 419.3 32 384 32zM400 416c0 8.822-7.178 16-16 16H64c-8.822 0-16-7.178-16-16V96c0-8.822 7.178-16 16-16h320c8.822 0 16 7.178 16 16V416z"/></svg>
                        </div>
                        <!--  <p class="notAllowedTitle">Oops,</p>  -->
                        <p class="notAllowedText">
                            You are not allowed to change this webmessage. 
                            Create a webmessage on the correct cluster to do so.
                        </p>
                        </div>
                    </div>
                    <textarea v-if="isAllowedToEdit" v-model="newText"></textarea>
                    <button v-show="isAllowedToEdit" :class="[error.state ? 'error' : '']" :disabled="done == true || error.state || isAllowedToEdit == false" @click="submitTrans">{{error.state == false ? 'Translate' : error.message}}</button>
                </div>
            

            </div>
        </transition>
    </wsm>
</template>

<script>
import { Component as VHTML } from '@staszek998/v-html'
export default {
    name: 'webmessage',
    props: ["text", "searchKey"],
    components: {
        VHTML
    },
    data() {
        return {
            openTranslator: false,
            loading: true,
            active: false,
            styleDisplay: 'block',
            done: false,
            parentWidth: 0,
            tag: undefined,
            howFarLeft: 0,
            oldTxt: this.text,
            itIsDoneCreating: false,
            newText: '',
            //error: false,
            error: {state: false, message: ''},
            link: '',
            template: '',
        // For info
            selectedCluster: '',
            language: '',
            siteURL: '',
        // Data Loading
           loadingData: true,
        // Update functionality
            isAllowedToEdit: true,
        }
    },
    updated() {
        this.template = `${this.newText}`
    },
    watch: {
        openTranslator: function() {
            if (!this.openTranslator) {
                this.enableLink()
            } else {
                this.disableLink();
                this.getClusterInfo();
            }
        }
    },
    mounted() {
        //console.log("GlobalComponent Webmassage" +this.$root.$options.name)

        if(typeof this.$root.isadmin == 'undefined' && this.$root.admin) {
            var nameOfApp = (typeof this.$root.$options.name != 'undefined') ? this.$root.$options.name : 'src/main.js or whatever you have called it'
            console.error('['+nameOfApp+'] isadmin is undefined or missing in $root. Your app needs isadmin in $root to check if you are allowed to change a webmessage')
        }
        // Get language and url of current site
        this.language = window.locale;
        this.siteURL = window.location.hostname;

        this.loading = true;
        this.newText = this.oldTxt
        var plep = this;
        window.addEventListener('load', (event) => {
            this.oldTxt = this.text;
            this.newText = this.text;
            this.howFarLeft = window.getComputedStyle(this.$el, null).width
            plep.loading = false;
        })
        if (this.$el.parentElement.getAttribute('href') != null) {
            this.link = this.$el.parentElement.getAttribute('href')
            this.$el.parentElement.addEventListener("click", function(event) {
                if (plep.openTranslator && plep.$el.parentElement.getAttribute('href') != null) {
                    plep.$el.parentElement.removeAttribute('href')
                }
            });
        }

    },
    methods: {
        htmlString(string, tag) {
            return `<` + tag + ` ${(typeof this.classes != 'undefined' ? 'class="'+this.classes+'"' : '')}>${string}</` + tag + `>`;
        },
        submitTrans() {
            axios.post(basedir + '/ajaxRequestServlet?mode=WebMessageAPI', null, {
                params: {
                    searchKey: this.searchKey,
                    clusterId: this.selectedCluster.clusterID,
                    newMsgTxt: encodeURIComponent(this.newText),
                    lang: locale
                }
            }, {
                headers: {
                    'Content-type': 'application/json',
                }
            }).then(response => {
                this.oldTxt = this.newText
                this.openTranslator = false;
            })
        },
        disableLink() {
            if (this.openTranslator && this.$el.parentElement.getAttribute('href') != null) {
                this.$el.parentElement.removeAttribute('href')
            }
        },
        enableLink() {
            setTimeout(() => {
                this.$el.parentElement.setAttribute('href', this.link)
            })

        },
        /// HGHANSEN
        getClusterInfo: function(){
        console.log("getClusterInfo is running")
        this.loadingData = true;
         axios.get(basedir + '/ajaxRequestServlet?mode=WebMessageAPI', {
            params: {
                chosenSearchKey: true,
                searchKey: this.searchKey,
            }
        }, {
            headers: {
                'Content-type': 'application/json',
            }
        }).then(response => {

            let clusters = response.data.clusters
            clusters.forEach(cluster => {
                if (cluster.clusterID == response.data.cluster) {
                    this.selectedCluster = cluster;
                }
            }) 
        // Debugging
            //console.log("///////// DEBUGGING")
            //    console.log(this.selectedCluster.clusterID, 'ClusterID');
            //    console.log(this.selectedCluster.clusterName, 'ClusterName')
            //    console.log(basedir, 'baseDir')
            //    console.log(this.siteURL, "siteURL")
            //console.log("///////// END DEBUGGING")
        // END Debugging

        // Is the site Nutriverse?
        // Logic for "is allowed to Edit" - If you are on nutriverse site, then you are only allowed to edit nutriverse webmessages
            if(this.siteURL.includes('nutriverse') || basedir == '/nutri'){
                //console.log("Site is nutriverse")
                this.isAllowedToEditChecker(1000120);
            }else if(this.siteURL.includes('med.pharmanord') || basedir == '/pnmed'){
                //console.log("SITE IS MEDICAL")
                this.isAllowedToEditChecker(1000119);
            } 
            else{
                //console.log("You can edit")
                this.isAllowedToEdit = true;
                this.error.state = false;
            }
            this.loadingData = false;
        })
        },
        isAllowedToEditChecker(clusterIDToCheck){
                if(this.selectedCluster.clusterID == clusterIDToCheck){
                    //console.log("You can edit this one")
                    this.isAllowedToEdit = true;
                    this.error.state = false;
                }else{
                    //console.log("You are not allowed to edit this one")
                    this.isAllowedToEdit = false;
                    this.error = {state: true, message: 'Not allowed to edit'}
                }  
        }
    },
    computed: {
        translationMode() {
            return window.translationMode
        }
    }
}
</script>

<style lang="scss" scoped>
wsm {
    position: relative;
    .langBtn {
        background: white !important;
        box-shadow: 0 3px 3px 0 rgba(46, 147, 63, 0.3) !important;
        padding: 4px !important;
        border-radius: 100% !important;
        height: 24px !important;
        box-sizing: unset !important;
        fill: #0ac257 !important;
        width: 24px !important;
        color: #0ac257 !important;
        font-family: "Font Awesome 5 Free" !important;
        font-size: 17px !important;
        vertical-align: sub !important;
        text-align: center !important;
        cursor: pointer !important;
        position: absolute !important;
        top: -18px !important;
        z-index: 99999;
        transition: all 0.2s ease-in-out !important;
        display: flex;
        justify-content: center;
        align-items: center;
        &:hover {
            transform: scale(1.1);
        }
        &.activeIcon {
            background: #0ac257 !important;
            fill: white !important;
        }
    }
}

.activeElHoverWsm {
    transition: padding 0.1s ease-in-out;

    border-radius: 2px;
    box-shadow: 0 0 0 2px #0ac257;
}

.wsmContainer {
    position: relative;
    display: inline-block;
    width: auto;
    &>* {
        display: inline-block;
    }
    .translateWindow {
        position: absolute;
        right: -325px;
        top: -25px;
        background: #eae1cc;
        padding: 12px;
        box-shadow: 0 0 14px 4px #00000066;
        border-radius: 8px;
        	z-index: 99999999;
        height: auto!important;
        width: 271px;
        display: flex!important;
        &InnerWrapper{
            display: block!important;
            height: auto!important;
        }
        .loadingWrapper{
            width: 100%;
            height:100%!important;
            position: absolute;
            left:0;
            top: 0;
            display: flex!important;
            justify-content: center;
            align-items: center;
            background: rgba(255, 255, 255, 0.6);

            .loadingIconWrapper{
                color: white;
                width: 50px;
                height: 50px!important;
                background: white;
                border-radius: 100%;
                display: flex!important;
                justify-content: center;
                align-items: center;
                position: relative;
                .loadingIconBackground{
                    display: block;
                    height: 40px!important;
                    width: 40px;
                    background: #0ac257;
                    display: flex !important;
                    justify-content: center;
                    align-items: center;
                    border-radius: 100%;
                    position: relative;
                }
                .loadingCircle{
                    background: #0ac257;
                    width: 100%;
                    height: 100% !important;
                    display: block !important;
                    position: absolute;
                    animation: circle 2s ease infinite;
                    transform: scale(0);
                    border-radius: 100%;
                    border: 2px solid white;
                }
                @keyframes circle{
                    0% {transform: scale(0)}
                    100%{transform: scale(1)}
                }
                .loadingIcon{
                    fill: white;
                    width: 30px;
                    height: 30px!important;
                    position: relative;
                    filter: drop-shadow(0px 2px 2px rgba(0, 0, 0, 0.4));
                }
            }
        }
        .infoContainer{
            .infoTitle{
                font-weight: bold;
                color: #0ac257!important;
                font-size: 12px;
                span{
                    font-size: inherit;
                }
            }
        }
        input {
            padding: 5px;
            font-weight: bold;
        }
        textarea {
            width: 98%;
            height: 149px;
        }
        button {
            width: 100%;
            padding: 5px;
            margin-top: 10px;
            font-size: 15px;
            border: none;
            background: #0ac257;
            cursor: pointer;
            color: white;
            &:hover {
                background: #1fcf69;
            }
        }
        .error {
            background: #e94949;
            user-select: none;
            cursor: default; 
            &:hover{
                background: #e94949;
            }
        }
    }
    .isTextArea {
        width: 374px;
    }
}
.notAllowedContainer{
    height: auto!important;
    display: block!important;
    background: white;
    box-shadow: 0 5px 3px 1px rgba(0, 0, 0, 0.3);
    border-radius: 5px;
    padding: 5px;
    margin-top: 10px;
    .notAllowedInnerWrapper{
        background: #ef6d62; 
        height: auto!important;
        //padding: 20px;
        
        padding: 20px 20px;
        display: flex!important;
    }
    .notAllowedIconWrapper{
        display: flex!important;
        justify-content: end;
        height: auto!important;

        margin-right: 20px;
        .notAllowedIcon{
            width: 40px;
            fill: rgba(255, 255, 255, 0.6)
            //fill: #e94949;     
        }
    }
    .notAllowedTitle{
        font-weight: bold;
        font-size: 35px;
    }
    .notAllowedText{
        color: white!important;
        font-size: 12px;
        font-family: Arial !important;
        text-align: left!important;
        //margin-top: 20px!important;
        font-weight: bold;    
        
        margin-top: 0!important;
    }
}
.close {
    position: absolute;
    right: -12px;
    top: -12px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 40px;
    width: 22px;
    height: 22px;
    padding: 2px;
    cursor: pointer;
    background: #f06363;
    color: white;
    box-shadow: 0 2px 4px 0px #f0636378;
    font-weight: bold;
    z-index: 10;
    transition: all .2s ease;
    svg{
        width: 50%;
        fill: white;
    }
    &:hover{
        background: darken(#f06363, 10%);
    }
}

.bounce-enter-active {
    animation: bounce-in .3s;
}

.bounce-leave-active {
    animation: bounce-in .3s reverse;
}

@keyframes bounce-in {
    0% {
        transform: scale(0);
    }
    50% {
        transform: scale(1.01);
    }
    100% {
        transform: scale(1);
    }
}

.fading-enter-active,
.fading-leave-active {
  animation: fading-in .5s;
}

.fading-enter-from,
.fading-leave-to {
  animation: fading-in .5s reverse;
}
@keyframes fading-in {
    0% {
        opacity: 0;
    }
    50% {opacity: 1;}
    100% {
        opacity: 1;
    }
}
@media screen and (max-width: 767px) {
.translateWindow{
    position: sticky!important;
    left: -100px;
}
}


</style>